import React from 'react'
import Layout from '../components/Layout'
import * as styles from '../styles/our-kombucha.module.scss'
import { graphql, Link } from 'gatsby'
import { getImage, StaticImage } from 'gatsby-plugin-image'
import Header from '../components/Header'
import { BgImage } from 'gbimage-bridge'
import VerveH1 from '../components/VerveH1'

export default function OurKombucha({ data }) {

  const banner = getImage(data.banner)
  const core_blueberries = getImage(data.core_blueberries)
  const core_strawberries = getImage(data.core_strawberries)
  const core_ginger = getImage(data.core_ginger)
  const core_lavender = getImage(data.core_lavender)
  const core_mint = getImage(data.core_mint)
  const core_sage = getImage(data.core_sage)
  
  
  return (
    <Layout pageTitle="Our Kombucha">
      <Header imageData={banner} bgClass={styles.header_bg}>
        <VerveH1 h1="our kombucha"/>
      </Header>
      <section className={styles.our_kombucha_bottles} id="main">
        <h2>Bottles</h2>
        <div className={styles.bottles_container}>
          <div className={styles.bottle}>
            <div className={styles.bottle_img}>
              <StaticImage 
                src="../images/bottles/bottle-blueberry.png" 
                alt="a bottle of blueberry, ginger, and lemon flavored Verve kombucha"
                placeholder="traced_SVG" 
                width={200}
              />
            </div>
            <div className={styles.bottle_copy}>
              <h3>Blueberry, Ginger, Lemon</h3>
              <p>Praesentium occaecati odit officiis labore dolores doloribus. Enim distinctio facere at numquam et quasi quia. Consequatur est dolorem omnis dolorem dolores eos vel. Praesentium occaecati odit officiis labore dolores doloribus.</p>
            </div>
          </div>
          <div className={styles.bottle}>
            <div className={styles.bottle_img}>
              <StaticImage 
                src="../images/bottles/bottle-lemon.png"
                alt="a bottle of lemon verbena flavored Verve kombucha"
                placeholder="traced_SVG"
                width={200}
              />
            </div>
            <div className={styles.bottle_copy}>
              <h3>Blueberry, Ginger, Lemon</h3>
              <p>Praesentium occaecati odit officiis labore dolores doloribus. Enim distinctio facere at numquam et quasi quia. Consequatur est dolorem omnis dolorem dolores eos vel. Praesentium occaecati odit officiis labore dolores doloribus.</p>
            </div>
          </div>
          <div className={styles.bottle}>
            <div className={styles.bottle_img}>
              <StaticImage
                src="../images/bottles/bottle-passionfruit.png"
                alt="a bottle of passionfruit, pear, cayenne flavored Verve kombucha"
                placeholder="traced_SVG"
                width={200}
              />
            </div>
            <div className={styles.bottle_copy}>
              <h3>Blueberry, Ginger, Lemon</h3>
              <p>Praesentium occaecati odit officiis labore dolores doloribus. Enim distinctio facere at numquam et quasi quia. Consequatur est dolorem omnis dolorem dolores eos vel. Praesentium occaecati odit officiis labore dolores doloribus.</p>
            </div>
          </div>
        </div>
      </section>
      <section className={styles.our_kombucha_tap}>
        <h2>On Tap</h2>
        <div className={styles.core_container}>
          <h3>Core Flavors</h3>
          <div className={styles.core_flavor}>
            <div className={styles.core_bg}>
              <BgImage
                Tag="div"
                image={core_blueberries}
                className={styles.core_flavor_img}
                backgroundColor={`rgba(239,93,162,0.6)`}
                placeholder="blurred"
              >
                <h4>Blueberry</h4>
              </BgImage>
            </div>
          </div>
          <div className={styles.core_flavor}>
            <div className={styles.core_bg}>
              <BgImage
                Tag="div"
                image={core_strawberries}
                className={styles.core_flavor_img}
                backgroundColor={`rgba(239,93,162,0.6)`}
                placeholder="blurred"
              >
                <h4>Strawberry</h4>
              </BgImage>
            </div>
          </div>
          <div className={styles.core_flavor}>
            <div className={styles.core_bg}>
              <BgImage
                Tag="div"
                image={core_ginger}
                className={styles.core_flavor_img}
                backgroundColor={`rgba(239,93,162,0.6)`}
                placeholder="blurred"
              >
                <h4>Ginger</h4>
              </BgImage>
            </div>
          </div>
          <div className={styles.core_flavor}>
            <div className={styles.core_bg}>
              <BgImage
                Tag="div"
                image={core_lavender}
                className={styles.core_flavor_img}
                backgroundColor={`rgba(239,93,162,0.6)`}
                placeholder="blurred"
              >
                <h4>Lavender</h4>
              </BgImage>
            </div>
          </div>
          <div className={styles.core_flavor}>
            <div className={styles.core_bg}>
              <BgImage
                Tag="div"
                image={core_mint}
                className={styles.core_flavor_img}
                backgroundColor={`rgba(239,93,162,0.6)`}
                placeholder="blurred"
              >
                <h4>Mint</h4>
              </BgImage>
            </div>
          </div>
          <div className={styles.core_flavor}>
            <div className={styles.core_bg}>
              <BgImage
                Tag="div"
                image={core_sage}
                className={styles.core_flavor_img}
                backgroundColor={`rgba(239,93,162,0.6)`}
                placeholder="blurred"
              >
                <h4>Sage</h4>
              </BgImage>
            </div>
          </div>
        </div>
        <div className={styles.seasonal_container}>
          <h3>Seasonal Flavors</h3>
          <p>Rotate throughout the season.</p>
          <p>Contact us for current offerings.</p>
          <Link to="/contact" className="button_slide">Contact Us</Link>
        </div>
      </section>
    </Layout>
  )
}

export const query = graphql`
  query {
    banner: file(relativePath: {eq: "verve_interior_ceiling.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH,
          placeholder: BLURRED
        )
      }
    }
    core_blueberries: file(relativePath: {eq: "core_flavors/blueberries.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH,
          placeholder: DOMINANT_COLOR
        )
      }
    }
    core_strawberries: file(relativePath: {eq: "core_flavors/strawberries.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH,
          placeholder: DOMINANT_COLOR
        )
      }
    }
    core_ginger: file(relativePath: {eq: "core_flavors/ginger.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH,
          placeholder: DOMINANT_COLOR
        )
      }
    }
    core_lavender: file(relativePath: {eq: "core_flavors/lavender.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH,
          placeholder: DOMINANT_COLOR
        )
      }
    }
    core_mint: file(relativePath: {eq: "core_flavors/mint.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH,
          placeholder: DOMINANT_COLOR
        )
      }
    }
    core_sage: file(relativePath: {eq: "core_flavors/sage.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH,
          placeholder: DOMINANT_COLOR
        )
      }
    }
  }
`;